
import Vue from 'vue';
import _ from 'lodash';
import { dateFormat } from '@/helpers/dateFormat';
import { joinArray } from '@/helpers/joinArray';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} }
  },
  computed: {
    quotationDetails: function() : any {
      return this.getVariable(this.input.variable);
    },
    termsAndConditions: function(): any {
      return _.get(this.quotationDetails, 'termsAndConditions', {});
    },
    tradeTerms: function(): { type: string, en: string, ar: string } {
      const tradeTermsList:{ type: string, en: string, ar: string }[]  = this.getVariable(this.input.config.tradeTermsListVariable);
      return _.find(tradeTermsList, (item) => item.type == this.termsAndConditions.tradeTerms.type) || { type: 'this.termsAndConditions.tradeTerms.type', en: '', ar: ''};
    },
    paymentTerms: function(): { alias: string, type: string, en: string, ar: string } | undefined {
      const paymentTermsList:{ alias: string, type: string, en: string, ar: string }[]  = this.getVariable(this.input.config.paymentTermsListVariable);
      return _.find(paymentTermsList, (item) => item.alias == this.termsAndConditions.paymentTerms.type);
    },
    tradeTermAddress: function(): string {
      const deliveryLocation = _.get(this.quotationDetails, 'deliveryLocations.0', '');
      const fullAddressComponents: any[] = _.get(_.find(this.quotationDetails.customer.deliveryAddresses, (address: any) => address.ref == deliveryLocation), 'location.address_components', []);
      const locality = _.get(_.find(fullAddressComponents, (addressComponent: any) => _.includes(addressComponent.types, 'locality')),'long_name');
      const country = _.get(_.find(fullAddressComponents, (addressComponent: any) => _.includes(addressComponent.types, 'country')),'long_name');
      return !!locality && !!country ?`${locality}, ${country}`: '';
    },
    deliveryLocations: function(): string {
      return joinArray(this.quotationDetails.deliveryLocations);
    }
  },
  methods: {
    formatDate: function(date: string, format?: string) {
      return dateFormat(date, format);
    }
  }
})
